module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"agarre":"Agarre","impermeabilizacion":"Impermeabilización","regularizacion":"Regularización","desolidarizacion":"Desolidarizacion","solera":"Solera","barrera_vapor":"Barrera de vapor","zahorra":"Zahorra"}}')
  delete Component.options._Ctor
}
